// Common component translations
import button from "./button.js";
import input from "./input.js";
import customerService from "./customer-service.js";
import chart from "./chart.js";

export default {
  button,
  input,
  customerService,
  chart,
  // Common messages
  languageSwitched: "Language switched to",
  loading: "Loading...",
  success: "Success",
  error: "Error",
  warning: "Warning",
  confirm: "Confirm",
  cancel: "Cancel",
  empty: "Currently no data",
  // Network request errors
  networkError: "Network error, please check your network or try again later",
  requestTimeout:
    "Request timeout, please check your network or try again later",
  // Professional feature prompt dialog ($tbProFeature)
  proFeature: {
    title: "System Notice",
    description:
      "This feature is only available to professional users. Please scan the QR code to contact customer service.",
    qrAlt: "Customer service QR code",
    confirm: "Got it",
  },
};
